import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import UserInfo from './UserInfo';
import AvatarSection from './AvatarSection';
import LogoutButton from '../auth/LogoutButton';
import DeleteAccountButton from '../auth/DeleteAccountButton';
import UsernameModal from '../modals/UsernameModal';
import './UserProfile.css';

const UserProfile = ({
  userData,
  apiError,
  showUsernameForm,
  onUsernameSet,
  onAvatarUpdate
}) => {
  const { user } = useAuth0();

  return (
    <div className="user-container">
      <h2>Your Profile</h2>

      {showUsernameForm && (
        <UsernameModal onSuccess={onUsernameSet} />
      )}

      <AvatarSection
        userData={userData}
        user={user}
        onAvatarUpdate={onAvatarUpdate}
      />

      <UserInfo userData={userData} user={user} />

      {apiError && (
        <div className="api-error">
          Backend sync error: {apiError}
        </div>
      )}

      <LogoutButton /> <DeleteAccountButton />
    </div>
  );
};

export default UserProfile;